












































import { companyProfile, EnterpriceData } from '@/store/interfaces/company';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'AggregatorModel',
  props: {
    companiesProfile: {
      type: Array as PropType<companyProfile[]>,
      required: true,
    },
    model: {
      type: Object as PropType<EnterpriceData>,
      required: true,
    },
  },
  computed: {
    syncedModel: {
      get(): EnterpriceData {
        return this.model;
      },
      set(value: EnterpriceData) {
        this.$emit('update:model', value);
      },
    },
  },
});
